/**
 * Crea un `ResizeObserver` che osserva tutti gli elementi passati (i `null` sono
 * ignorati, comodo con liste ottenute da `document.getElementById`). Ritorna
 * `null` dove l'API non esiste (SSR / ambienti di test senza polyfill), così il
 * chiamante degrada senza crashare.
 *
 * Utile quando gli elementi da osservare NON sono renderizzati dal componente
 * stesso (e quindi `react-cool-dimensions`, che vuole un ref sul proprio JSX,
 * non è applicabile): es. card individuate per `id` altrove nel DOM.
 */
export function observeResize(
  targets: Array<Element | null>,
  onResize: () => void,
): ResizeObserver | null {
  // Fuori dal browser (SSR) o nei test senza polyfill l'API non c'è: niente
  // observer, il chiamante gestisce il caso `null` senza crashare.
  if (typeof ResizeObserver === 'undefined') return null;
  // Un solo observer per tutti i target: la stessa callback scatta a ogni
  // variazione di dimensione di uno qualsiasi degli elementi osservati.
  const observer = new ResizeObserver(onResize);
  // Scorriamo i target da osservare.
  for (const target of targets) {
    // Ignoriamo i `null` (comodo con liste da `document.getElementById`) e
    // registriamo solo gli elementi realmente presenti.
    if (target) observer.observe(target);
  }
  // Restituiamo l'observer così il chiamante può fare `disconnect()` in cleanup.
  return observer;
}
